/* eslint-disable */
import { notification } from "antd";

const openNotificationWithIcon = (type, content, duration) => {
  notification[type]({
    message: content,
    duration: duration,
  });
};
export const notifySuccess = (content) => {
  if (content) openNotificationWithIcon("success", content, 3);
};
export const notifyError = (content) => {
  if (content) openNotificationWithIcon("error", content, 3);
};
export const notifyWarning = (content) => {
  if (content) openNotificationWithIcon("warning", content, 3);
};
